export const CommandCenterIcon = {
  facebook_like_white: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 15 13.15"
    >
      <defs>
        <clipPath id="a">
          <path
            data-name="Rectangle 12038"
            fill="#fff"
            stroke="var(--nonactionable-icon-color,#fff)"
            d="M0 0h16v16H0z"
          />
        </clipPath>
      </defs>
      <g data-name="Mask Group 341" clipPath="url(#a)">
        <g data-name="Layer 2">
          <g data-name="invisible box">
            <path data-name="Rectangle 12039" fill="none" d="M0 0h16v16H0z" />
          </g>
          <g data-name="icons Q2">
            <path
              data-name="Path 15950"
              d="M12.667 5.667h-2.334l.133-1.1c.2-1.633-.133-2.933-1.2-3.233h-.1a.667.667 0 0 0-.5.4S6.333 6.667 5.333 6.667H1.667A.667.667 0 0 0 1 7.333v5.333a.667.667 0 0 0 .667.667H6.1a.533.533 0 0 1 .4.133 7.292 7.292 0 0 0 2.833 1.2H11c1.967 0 3.667-1.333 3.833-3.967L15 8a2.233 2.233 0 0 0-2.333-2.333zM2.333 8h2v4h-2zM13.5 10.6c-.133 1.733-1.067 2.733-2.5 2.733H9.333A7.33 7.33 0 0 1 7.3 12.4a1.933 1.933 0 0 0-1.2-.4h-.433V8c.633-.133 1.667-.733 3.5-4.267a5.4 5.4 0 0 1-.033.7L9 5.533 8.833 7h3.833a.9.9 0 0 1 1 .967z"
              fill="var(--nonactionable-icon-color,#fff)"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  facebook_like: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 15 13.15"
    >
      <defs>
        <clipPath id="a">
          <path
            data-name="Rectangle 12038"
            fill="#2d3e5c"
            stroke="#707070"
            d="M0 0h15.315v16H0z"
          />
        </clipPath>
      </defs>
      <g data-name="Mask Group 341" clipPath="url(#a)">
        <g data-name="Layer 2">
          <g data-name="invisible box">
            <path
              data-name="Rectangle 12039"
              fill="none"
              d="M0 0h15.315v16H0z"
            />
          </g>
          <g data-name="icons Q2">
            <path
              data-name="Path 15950"
              d="M12.124 5.667H9.891l.128-1.1c.191-1.633-.128-2.933-1.149-3.233h-.1a.644.644 0 0 0-.479.4S6.062 6.667 5.105 6.667h-3.51a.653.653 0 0 0-.638.666v5.333a.653.653 0 0 0 .638.667h4.244a.5.5 0 0 1 .383.133 6.827 6.827 0 0 0 2.712 1.2h1.6c1.883 0 3.51-1.333 3.669-3.967L14.357 8a2.289 2.289 0 0 0-.624-1.682 2.089 2.089 0 0 0-1.61-.652ZM2.233 8h1.915v4H2.233Zm10.689 2.6c-.128 1.733-1.021 2.733-2.393 2.733h-1.6a6.878 6.878 0 0 1-1.942-.933 1.8 1.8 0 0 0-1.148-.4h-.415V8c.606-.133 1.6-.733 3.35-4.267a5.639 5.639 0 0 1-.032.7l-.128 1.1L8.457 7h3.669a.839.839 0 0 1 .7.247.923.923 0 0 1 .26.72Z"
              fill="var(--nonactionable-icon-color,#2d3e5c)"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  upvote: (
    <svg
      data-name="Layer 2"
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 15 13.15"
    >
      <g data-name="invisible box">
        <path data-name="Rectangle 140737" fill="none" d="M0 0h19v19H0z" />
      </g>
      <g data-name="Q3 icons">
        <path
          data-name="Path 48198"
          d="m9.5 3.642 5.344 6.008h-3.8v5.926H7.956V9.65h-3.8L9.5 3.642m0-2.058a.853.853 0 0 0-.594.247L1.821 9.856a.845.845 0 0 0-.212.924.791.791 0 0 0 .766.517h4v5.1a.808.808 0 0 0 .792.823h4.664a.808.808 0 0 0 .8-.821v-5.1h4a.791.791 0 0 0 .766-.517.845.845 0 0 0-.212-.924l-7.092-8.027a.853.853 0 0 0-.593-.247Z"
          fill="var(--nonactionable-icon-color,#3b5175)"
        />
      </g>
    </svg>
  ),
  upvote_white: (
    <svg
      data-name="Layer 2"
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 15 13.15"
    >
      <g data-name="invisible box">
        <path data-name="Rectangle 140737" fill="none" d="M0 0h19v19H0z" />
      </g>
      <g data-name="Q3 icons">
        <path
          data-name="Path 48198"
          d="m9.5 3.642 5.344 6.008h-3.8v5.926H7.956V9.65h-3.8L9.5 3.642m0-2.058a.853.853 0 0 0-.594.247L1.821 9.856a.845.845 0 0 0-.212.924.791.791 0 0 0 .766.517h4v5.1a.808.808 0 0 0 .792.823h4.664a.808.808 0 0 0 .8-.821v-5.1h4a.791.791 0 0 0 .766-.517.845.845 0 0 0-.212-.924l-7.092-8.027a.853.853 0 0 0-.593-.247Z"
          fill="var(--nonactionable-icon-color,#fff)"
        />
      </g>
    </svg>
  ),
  facebook_share: (
    <svg xmlns="http://www.w3.org/2000/svg" width="15.315" height="15.315">
      <defs>
        <clipPath id="a">
          <path
            data-name="Rectangle 12040"
            fill="#2d3e5c"
            stroke="#707070"
            d="M0 0h15.315v15.315H0z"
          />
        </clipPath>
      </defs>
      <g data-name="Mask Group 342" clipPath="url(#a)">
        <g data-name="Layer 2">
          <g data-name="invisible box">
            <path
              data-name="Rectangle 12041"
              fill="none"
              d="M0 0h15.315v16H0z"
            />
          </g>
          <g data-name="icons Q2">
            <path
              data-name="Path 15951"
              d="M11.806 9.333a2.453 2.453 0 0 0-2.01 1.033L5.393 8.4a1.7 1.7 0 0 0 .031-.4 1.7 1.7 0 0 0-.032-.4l4.4-1.967a2.453 2.453 0 0 0 2.01 1.033A2.611 2.611 0 0 0 14.358 4a2.555 2.555 0 1 0-5.105 0 1.7 1.7 0 0 0 .032.4L4.886 6.367a2.453 2.453 0 0 0-2.01-1.033A2.611 2.611 0 0 0 .319 8a2.611 2.611 0 0 0 2.553 2.667 2.453 2.453 0 0 0 2.014-1.034l4.4 1.967a1.7 1.7 0 0 0-.032.4 2.555 2.555 0 1 0 2.552-2.667Zm0-6.667A1.306 1.306 0 0 1 13.086 4a1.277 1.277 0 1 1-2.553 0 1.306 1.306 0 0 1 1.273-1.333ZM2.872 9.333a1.335 1.335 0 0 1 0-2.667 1.335 1.335 0 0 1 0 2.667Zm8.934 4A1.335 1.335 0 1 1 13.086 12a1.306 1.306 0 0 1-1.28 1.333Z"
              fill="var(--nonactionable-icon-color,#2d3e5c)"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  facebook_share_white: (
    <svg xmlns="http://www.w3.org/2000/svg" width="15.315" height="15.315">
      <defs>
        <clipPath id="a">
          <path
            data-name="Rectangle 12040"
            fill="#fff"
            stroke="#707070"
            d="M0 0h15.315v15.315H0z"
          />
        </clipPath>
      </defs>
      <g data-name="Mask Group 342" clipPath="url(#a)">
        <g data-name="Layer 2">
          <g data-name="invisible box">
            <path
              data-name="Rectangle 12041"
              fill="none"
              d="M0 0h15.315v16H0z"
            />
          </g>
          <g data-name="icons Q2">
            <path
              data-name="Path 15951"
              d="M11.806 9.333a2.453 2.453 0 0 0-2.01 1.033L5.393 8.4a1.7 1.7 0 0 0 .031-.4 1.7 1.7 0 0 0-.032-.4l4.4-1.967a2.453 2.453 0 0 0 2.01 1.033A2.611 2.611 0 0 0 14.358 4a2.555 2.555 0 1 0-5.105 0 1.7 1.7 0 0 0 .032.4L4.886 6.367a2.453 2.453 0 0 0-2.01-1.033A2.611 2.611 0 0 0 .319 8a2.611 2.611 0 0 0 2.553 2.667 2.453 2.453 0 0 0 2.014-1.034l4.4 1.967a1.7 1.7 0 0 0-.032.4 2.555 2.555 0 1 0 2.552-2.667Zm0-6.667A1.306 1.306 0 0 1 13.086 4a1.277 1.277 0 1 1-2.553 0 1.306 1.306 0 0 1 1.273-1.333ZM2.872 9.333a1.335 1.335 0 0 1 0-2.667 1.335 1.335 0 0 1 0 2.667Zm8.934 4A1.335 1.335 0 1 1 13.086 12a1.306 1.306 0 0 1-1.28 1.333Z"
              fill="var(--nonactionable-icon-color,#fff)" //"#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  instagram_share: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11.797"
      height="11.811"
      viewBox="0 0 11.797 11.811"
    >
      <g id="Insta_share" transform="translate(-6.021 -5.998)">
        <path
          id="Path_59997"
          data-name="Path 59997"
          d="M17.682,6.141a.492.492,0,0,0-.517-.113L6.34,9.965a.492.492,0,0,0,0,.92l4.724,1.89,1.89,4.724a.475.475,0,0,0,.9-.015L17.785,6.658A.492.492,0,0,0,17.682,6.141Zm-4.286,9.8-1.373-3.445,2.357-2.357-.694-.694L11.309,11.82,7.885,10.427l8.626-3.115Z"
          transform="translate(0 0)"
          fill="var(--nonactionable-icon-color,#2d3e5c)"
        />
      </g>
    </svg>
  ),
  instagram_share_white: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11.797"
      height="11.811"
      viewBox="0 0 11.797 11.811"
    >
      <g id="Insta_share" transform="translate(-6.021 -5.998)">
        <path
          id="Path_59997"
          data-name="Path 59997"
          d="M17.682,6.141a.492.492,0,0,0-.517-.113L6.34,9.965a.492.492,0,0,0,0,.92l4.724,1.89,1.89,4.724a.475.475,0,0,0,.9-.015L17.785,6.658A.492.492,0,0,0,17.682,6.141Zm-4.286,9.8-1.373-3.445,2.357-2.357-.694-.694L11.309,11.82,7.885,10.427l8.626-3.115Z"
          transform="translate(0 0)"
          fill="var(--nonactionable-icon-color,#fff)"
        />
      </g>
    </svg>
  ),
  youtube_share: (
    <svg xmlns="http://www.w3.org/2000/svg" width="13.37" height="11.329">
      <path
        d="M12.761 4.828 8.218.578a.232.232 0 0 0-.18-.077c-.142.006-.322.106-.322.258V2.89a.138.138 0 0 1-.116.132c-4.519.692-6.422 4.073-7.099 7.583-.026.138.161.267.248.158a8.213 8.213 0 0 1 6.826-3.459.159.159 0 0 1 .135.154v2.093a.277.277 0 0 0 .467.171l4.576-4.325a.356.356 0 0 0 .113-.271.431.431 0 0 0-.109-.3Z"
        fill="none"
        stroke="var(--nonactionable-icon-color,#2d3e5c)"
      />
    </svg>
  ),
  youtube_share_white: (
    <svg xmlns="http://www.w3.org/2000/svg" width="13.37" height="11.329">
      <path
        d="M12.761 4.828 8.218.578a.232.232 0 0 0-.18-.077c-.142.006-.322.106-.322.258V2.89a.138.138 0 0 1-.116.132c-4.519.692-6.422 4.073-7.099 7.583-.026.138.161.267.248.158a8.213 8.213 0 0 1 6.826-3.459.159.159 0 0 1 .135.154v2.093a.277.277 0 0 0 .467.171l4.576-4.325a.356.356 0 0 0 .113-.271.431.431 0 0 0-.109-.3Z"
        fill="none"
        stroke="var(--nonactionable-icon-color,#fff)"
      />
    </svg>
  ),
  video_view: (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10.267">
      <g fill="var(--nonactionable-icon-color,#2d3e5c)">
        <path
          data-name="Path 21796"
          d="M13.974 4.975A7.789 7.789 0 0 0 7 0 7.789 7.789 0 0 0 .028 4.975a.467.467 0 0 0 0 .317A7.789 7.789 0 0 0 7 10.267a7.789 7.789 0 0 0 6.974-4.975.467.467 0 0 0 0-.317ZM7 9.334a6.93 6.93 0 0 1-6.034-4.2A6.929 6.929 0 0 1 7 .934a6.929 6.929 0 0 1 6.034 4.2A6.93 6.93 0 0 1 7 9.334Z"
        />
        <path
          data-name="Path 21797"
          d="M7 2.333a2.8 2.8 0 1 0 2.8 2.8 2.8 2.8 0 0 0-2.8-2.8ZM7 7a1.867 1.867 0 1 1 1.867-1.867A1.867 1.867 0 0 1 7 7Z"
        />
      </g>
    </svg>
  ),
  video_view_white: (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10.267">
      <g fill="var(--nonactionable-icon-color,#fff)">
        <path
          data-name="Path 21796"
          d="M13.974 4.975A7.789 7.789 0 0 0 7 0 7.789 7.789 0 0 0 .028 4.975a.467.467 0 0 0 0 .317A7.789 7.789 0 0 0 7 10.267a7.789 7.789 0 0 0 6.974-4.975.467.467 0 0 0 0-.317ZM7 9.334a6.93 6.93 0 0 1-6.034-4.2A6.929 6.929 0 0 1 7 .934a6.929 6.929 0 0 1 6.034 4.2A6.93 6.93 0 0 1 7 9.334Z"
        />
        <path
          data-name="Path 21797"
          d="M7 2.333a2.8 2.8 0 1 0 2.8 2.8 2.8 2.8 0 0 0-2.8-2.8ZM7 7a1.867 1.867 0 1 1 1.867-1.867A1.867 1.867 0 0 1 7 7Z"
        />
      </g>
    </svg>
  ),
  like_icon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 15 13.15"
    >
      <path d="M0 0h15v15H0z" style={{ fill: "none" }} />
      <path
        d="M15.239 3.738a4.361 4.361 0 0 0-5.743.82 4.353 4.353 0 0 0-5.743-.82A4.074 4.074 0 0 0 2 6.937c-.1 2.893 2.474 5.212 6.41 8.768l.075.067a1.5 1.5 0 0 0 2.017-.007l.082-.075c3.936-3.549 6.507-5.868 6.41-8.761a4.072 4.072 0 0 0-1.755-3.191zM9.571 14.594l-.075.075-.075-.075C5.852 11.38 3.5 9.255 3.5 7.1a2.555 2.555 0 0 1 2.624-2.61A2.931 2.931 0 0 1 8.8 6.251h1.4a2.913 2.913 0 0 1 2.669-1.76A2.555 2.555 0 0 1 15.494 7.1c0 2.155-2.355 4.28-5.923 7.494z"
        transform="translate(-1.996 -2.193)"
        style={{ fill: "var(--nonactionable-icon-color,#2d3e5c)" }}
      />
    </svg>
  ),
  like_white_icon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 15 13.15"
    >
      <path d="M0 0h15v15H0z" style={{ fill: "none" }} />
      <path
        d="M15.239 3.738a4.361 4.361 0 0 0-5.743.82 4.353 4.353 0 0 0-5.743-.82A4.074 4.074 0 0 0 2 6.937c-.1 2.893 2.474 5.212 6.41 8.768l.075.067a1.5 1.5 0 0 0 2.017-.007l.082-.075c3.936-3.549 6.507-5.868 6.41-8.761a4.072 4.072 0 0 0-1.755-3.191zM9.571 14.594l-.075.075-.075-.075C5.852 11.38 3.5 9.255 3.5 7.1a2.555 2.555 0 0 1 2.624-2.61A2.931 2.931 0 0 1 8.8 6.251h1.4a2.913 2.913 0 0 1 2.669-1.76A2.555 2.555 0 0 1 15.494 7.1c0 2.155-2.355 4.28-5.923 7.494z"
        transform="translate(-1.996 -2.193)"
        style={{ fill: "var(--nonactionable-icon-color,#fff)" }}
      />
    </svg>
  ),

  comment_icon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 15 13.15"
    >
      <path
        d="M6.783 16.727a.46.46 0 0 1-.212 0 .472.472 0 0 1-.236-.483v-2.357a3.442 3.442 0 0 1-2.982-3.395V6.613a3.43 3.43 0 0 1 3.43-3.418h6.247a3.43 3.43 0 0 1 3.43 3.418v3.878a3.43 3.43 0 0 1-3.43 3.418h-2.581l-3.36 2.711a.507.507 0 0 1-.306.107zm-.036-12.66a2.523 2.523 0 0 0-2.534 2.546v3.878a2.523 2.523 0 0 0 2.534 2.523.448.448 0 0 1 .448.448V15.4L10 13.132a.507.507 0 0 1 .318-.118h2.676a2.523 2.523 0 0 0 2.534-2.523V6.613a2.523 2.523 0 0 0-2.534-2.546z"
        transform="translate(-3.103 -2.945)"
        style={{
          fill: "var(--nonactionable-icon-color,#2d3e5c)",
          stroke: "var(--nonactionable-icon-color,#2d3e5c)",
          strokeWidth: ".5px",
        }}
      />
    </svg>
  ),
  comment_white_icon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 15 13.15"
    >
      <path
        d="M6.783 16.727a.46.46 0 0 1-.212 0 .472.472 0 0 1-.236-.483v-2.357a3.442 3.442 0 0 1-2.982-3.395V6.613a3.43 3.43 0 0 1 3.43-3.418h6.247a3.43 3.43 0 0 1 3.43 3.418v3.878a3.43 3.43 0 0 1-3.43 3.418h-2.581l-3.36 2.711a.507.507 0 0 1-.306.107zm-.036-12.66a2.523 2.523 0 0 0-2.534 2.546v3.878a2.523 2.523 0 0 0 2.534 2.523.448.448 0 0 1 .448.448V15.4L10 13.132a.507.507 0 0 1 .318-.118h2.676a2.523 2.523 0 0 0 2.534-2.523V6.613a2.523 2.523 0 0 0-2.534-2.546z"
        transform="translate(-3.103 -2.945)"
        style={{
          fill: "var(--nonactionable-icon-color,#fff)",
          stroke: "var(--nonactionable-icon-color,#fff)",
          strokeWidth: ".5px",
        }}
      />
    </svg>
  ),
  postClick_white: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16.553"
      height="16.439"
      viewBox="0 0 16.553 16.439"
    >
      <g id="Layer_2" data-name="Layer 2" transform="translate(-0.01 -0.084)">
        <g id="Layer_1" data-name="Layer 1" transform="translate(0.01 0.084)">
          <g id="Layer_1-2" data-name="Layer 1-2">
            <path
              id="Path_59909"
              data-name="Path 59909"
              d="M16.881,14.873l-2.77-2.77,1.974-1.144a.474.474,0,0,0,.237-.432.491.491,0,0,0-.3-.4L7.216,6.614a.457.457,0,0,0-.6.271.449.449,0,0,0,0,.33l3.515,8.81a.44.44,0,0,0,.4.3.457.457,0,0,0,.432-.237L12.1,14.111l2.77,2.77a.46.46,0,0,0,.652,0l1.355-1.347a.474.474,0,0,0,0-.661Z"
              transform="translate(-1.015 -1.077)"
              fill="none"
              stroke="var(--nonactionable-icon-color,#fff)"
              strokeMiterlimit="10"
              strokeWidth="1"
            />
            <path
              id="Path_59910"
              data-name="Path 59910"
              d="M3.265,2.458a.6.6,0,1,0-.847.847L3.731,4.585a.6.6,0,1,0,.847-.847Z"
              transform="translate(-0.351 -0.42)"
              fill="var(--nonactionable-icon-color,#fff)"
            />
            <path
              id="Path_59911"
              data-name="Path 59911"
              d="M2.788,8.352a.542.542,0,0,0-.542-.542H.552a.542.542,0,1,0,0,1.084H2.246a.534.534,0,0,0,.542-.534Z"
              transform="translate(-0.01 -1.265)"
              fill="var(--nonactionable-icon-color,#fff)"
            />
            <path
              id="Path_59912"
              data-name="Path 59912"
              d="M3.3,11.708l-1.33,1.321a.6.6,0,0,0,.847.847l1.321-1.321a.6.6,0,0,0,0-.847.584.584,0,0,0-.839,0Z"
              transform="translate(-0.283 -1.834)"
              fill="var(--nonactionable-icon-color,#fff)"
            />
            <path
              id="Path_59913"
              data-name="Path 59913"
              d="M8.351,2.808a.542.542,0,0,0,.542-.534h0V.58A.551.551,0,0,0,7.8.555h0V2.249a.551.551,0,0,0,.551.559Z"
              transform="translate(-1.201 -0.084)"
              fill="var(--nonactionable-icon-color,#fff)"
            />
            <path
              id="Path_59914"
              data-name="Path 59914"
              d="M12.235,4.2a.491.491,0,0,0,.364-.152l1.152-1.152a.508.508,0,0,0,0-.72h0a.508.508,0,0,0-.728,0L11.862,3.307a.508.508,0,0,0,0,.729A.491.491,0,0,0,12.235,4.2Z"
              transform="translate(-1.799 -0.38)"
              fill="var(--nonactionable-icon-color,#fff)"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  postClick_black: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16.553"
      height="16.439"
      viewBox="0 0 16.553 16.439"
    >
      <g id="Layer_2" data-name="Layer 2" transform="translate(-0.01 -0.084)">
        <g id="Layer_1" data-name="Layer 1" transform="translate(0.01 0.084)">
          <g id="Layer_1-2" data-name="Layer 1-2">
            <path
              id="Path_59909"
              data-name="Path 59909"
              d="M16.881,14.873l-2.77-2.77,1.974-1.144a.474.474,0,0,0,.237-.432.491.491,0,0,0-.3-.4L7.216,6.614a.457.457,0,0,0-.6.271.449.449,0,0,0,0,.33l3.515,8.81a.44.44,0,0,0,.4.3.457.457,0,0,0,.432-.237L12.1,14.111l2.77,2.77a.46.46,0,0,0,.652,0l1.355-1.347a.474.474,0,0,0,0-.661Z"
              transform="translate(-1.015 -1.077)"
              fill="none"
              stroke="var(--nonactionable-icon-color,#2d3e5c)"
              strokeMiterlimit="10"
              strokeWidth="1"
            />
            <path
              id="Path_59910"
              data-name="Path 59910"
              d="M3.265,2.458a.6.6,0,1,0-.847.847L3.731,4.585a.6.6,0,1,0,.847-.847Z"
              transform="translate(-0.351 -0.42)"
              fill="var(--nonactionable-icon-color,#2d3e5c)"
            />
            <path
              id="Path_59911"
              data-name="Path 59911"
              d="M2.788,8.352a.542.542,0,0,0-.542-.542H.552a.542.542,0,1,0,0,1.084H2.246a.534.534,0,0,0,.542-.534Z"
              transform="translate(-0.01 -1.265)"
              fill="var(--nonactionable-icon-color,#2d3e5c)"
            />
            <path
              id="Path_59912"
              data-name="Path 59912"
              d="M3.3,11.708l-1.33,1.321a.6.6,0,0,0,.847.847l1.321-1.321a.6.6,0,0,0,0-.847.584.584,0,0,0-.839,0Z"
              transform="translate(-0.283 -1.834)"
              fill="var(--nonactionable-icon-color,#2d3e5c)"
            />
            <path
              id="Path_59913"
              data-name="Path 59913"
              d="M8.351,2.808a.542.542,0,0,0,.542-.534h0V.58A.551.551,0,0,0,7.8.555h0V2.249a.551.551,0,0,0,.551.559Z"
              transform="translate(-1.201 -0.084)"
              fill="var(--nonactionable-icon-color,#2d3e5c)"
            />
            <path
              id="Path_59914"
              data-name="Path 59914"
              d="M12.235,4.2a.491.491,0,0,0,.364-.152l1.152-1.152a.508.508,0,0,0,0-.72h0a.508.508,0,0,0-.728,0L11.862,3.307a.508.508,0,0,0,0,.729A.491.491,0,0,0,12.235,4.2Z"
              transform="translate(-1.799 -0.38)"
              fill="var(--nonactionable-icon-color,#2d3e5c)"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  delete_post: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Delete">
        <path
          id="Vector"
          d="M4.87504 7.62055L5.12504 15.1874C5.14634 15.8355 5.41934 16.4497 5.8861 16.8998C6.35286 17.3499 6.97664 17.6004 7.62504 17.5981H12.375C13.023 17.6004 13.6464 17.3503 14.1131 16.9007C14.5798 16.4512 14.8531 15.8375 14.875 15.1899L15.125 7.62055C15.1305 7.45479 15.0699 7.29365 14.9566 7.17257C14.8432 7.05149 14.6864 6.9804 14.5207 6.97493C14.3549 6.96946 14.1938 7.03006 14.0727 7.1434C13.9516 7.25674 13.8805 7.41354 13.875 7.5793L13.625 15.1481C13.6126 15.4712 13.4754 15.7769 13.2423 16.001C13.0093 16.2251 12.6984 16.3502 12.375 16.3499H7.62504C7.30128 16.3501 6.99006 16.2247 6.75691 16.0001C6.52376 15.7754 6.38686 15.4691 6.37504 15.1456L6.12504 7.5793C6.11957 7.41354 6.04848 7.25674 5.9274 7.1434C5.80632 7.03006 5.64518 6.96946 5.47942 6.97493C5.31366 6.9804 5.15686 7.05149 5.04352 7.17257C4.93018 7.29365 4.86957 7.45479 4.87504 7.62055ZM4.04817 5.10243C4.04817 5.26819 4.11402 5.42716 4.23123 5.54437C4.34844 5.66158 4.50741 5.72743 4.67317 5.72743H15.3263C15.4921 5.72743 15.651 5.66158 15.7682 5.54437C15.8854 5.42716 15.9513 5.26819 15.9513 5.10243C15.9513 4.93667 15.8854 4.7777 15.7682 4.66049C15.651 4.54328 15.4921 4.47743 15.3263 4.47743H13.3888C13.1908 4.47796 12.9996 4.4048 12.8526 4.27218C12.7055 4.13955 12.613 3.95696 12.5932 3.75993C12.547 3.29773 12.3305 2.86926 11.9857 2.558C11.641 2.24673 11.1927 2.07497 10.7282 2.07618H9.27192C8.80743 2.07497 8.35912 2.24673 8.01435 2.558C7.66958 2.86926 7.45304 3.29773 7.40692 3.75993C7.38705 3.95696 7.29459 4.13955 7.14753 4.27218C7.00047 4.4048 6.80932 4.47796 6.61129 4.47743H4.67379C4.50803 4.47743 4.34906 4.54328 4.23185 4.66049C4.11464 4.7777 4.04879 4.93667 4.04879 5.10243H4.04817ZM11.5082 4.47743H8.49067C8.5728 4.28977 8.62651 4.09092 8.65004 3.88743C8.66553 3.73337 8.73764 3.59054 8.85242 3.48662C8.9672 3.3827 9.11646 3.32508 9.27129 3.32493H10.7275C10.8824 3.32508 11.0316 3.3827 11.1464 3.48662C11.2612 3.59054 11.3333 3.73337 11.3488 3.88743C11.3725 4.09095 11.4258 4.2898 11.5082 4.47743ZM10.8788 13.9468V8.62493C10.8788 8.45917 10.9446 8.3002 11.0619 8.18299C11.1791 8.06578 11.338 7.99993 11.5038 7.99993C11.6696 7.99993 11.8285 8.06578 11.9457 8.18299C12.0629 8.3002 12.1288 8.45917 12.1288 8.62493V13.9493C12.1288 14.1151 12.0629 14.274 11.9457 14.3912C11.8285 14.5085 11.6696 14.5743 11.5038 14.5743C11.338 14.5743 11.1791 14.5085 11.0619 14.3912C10.9446 14.274 10.8788 14.1151 10.8788 13.9493V13.9468ZM7.87004 13.9468V8.62493C7.87004 8.45917 7.93589 8.3002 8.0531 8.18299C8.17031 8.06578 8.32928 7.99993 8.49504 7.99993C8.6608 7.99993 8.81978 8.06578 8.93699 8.18299C9.0542 8.3002 9.12004 8.45917 9.12004 8.62493V13.9493C9.12004 14.1151 9.0542 14.274 8.93699 14.3912C8.81978 14.5085 8.6608 14.5743 8.49504 14.5743C8.32928 14.5743 8.17031 14.5085 8.0531 14.3912C7.93589 14.274 7.87004 14.1151 7.87004 13.9493V13.9468Z"
          fill="#FF5D48" //"#FF5D48" //
        />
      </g>
    </svg>
  ),
  hide_post: (
    <svg
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="hidden" clipPath="url(#clip0_1299_1105)">
        <g id="Layer 2">
          <g id="Layer 1">
            <path
              id="Vector"
              d="M7.99995 2.63596C9.33752 2.63011 10.6494 3.00125 11.7841 3.7065C12.9188 4.41174 13.83 5.4223 14.4122 6.62139C13.991 7.48686 13.3941 8.25591 12.6591 8.87996L13.7034 9.90102C14.728 9.00272 15.5219 7.87338 16.0189 6.60728C15.2126 4.57974 13.6614 2.93386 11.6805 2.00397C9.69963 1.07408 7.43754 0.929926 5.35376 1.60078L6.554 2.79594C7.02945 2.69496 7.51383 2.64137 7.99995 2.63596Z"
              fill="var(--nonactionable-icon-color,#F0C52F)"
            />
            <path
              id="Vector_2"
              d="M7.22032 3.46416L8.7277 4.96046L9.67277 5.90153L11.1754 7.40254C11.3032 6.92194 11.3175 6.4184 11.2171 5.9314C11.1167 5.4444 10.9043 4.98719 10.5967 4.59561C10.289 4.20404 9.8945 3.88876 9.44397 3.67449C8.99345 3.46022 8.49921 3.3528 8 3.36064C7.73673 3.36173 7.47468 3.39652 7.22032 3.46416ZM0.732428 1.09737L2.68399 3.03597C1.4829 3.97011 0.555921 5.20843 0 6.62145C0.833484 8.73414 2.47562 10.4306 4.56519 11.3378C6.65475 12.2449 9.02061 12.2883 11.1424 11.4585L13.6279 13.9336L14.6486 12.9125L1.75783 0.0668945L0.732428 1.09737ZM3.71412 4.06644L4.98996 5.33218C4.81318 5.73247 4.72301 6.16534 4.72534 6.60263C4.72396 7.13817 4.85602 7.66569 5.1097 8.13792C5.36338 8.61015 5.73076 9.01233 6.1789 9.30842C6.62704 9.60452 7.14195 9.78529 7.67749 9.83452C8.21304 9.88375 8.75248 9.79992 9.24749 9.59052L9.27584 9.61876L9.98937 10.3293C9.33833 10.5087 8.66607 10.6005 7.99055 10.6022C6.655 10.6042 5.34582 10.232 4.21271 9.52805C3.0796 8.8241 2.16829 7.81684 1.58299 6.62145C2.08278 5.61544 2.81273 4.7403 3.71412 4.06644Z"
              fill="var(--nonactionable-icon-color,#F0C52F)"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1299_1105">
          <rect
            width="16"
            height="13.8667"
            fill="white"
            transform="translate(0 0.0668945)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  //"#6a8eff"
  deep_link_icon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="15.56"
      viewBox="-1 0 17.65 13.55"
    >
      <path
        data-name="carnet (1)"
        d="M13.827 1.224H9.562a1.836 1.836 0 0 0-3.461 0H1.836A1.838 1.838 0 0 0 0 3.059v8.657a1.838 1.838 0 0 0 1.836 1.835h11.993a1.838 1.838 0 0 0 1.834-1.835V3.059a1.838 1.838 0 0 0-1.836-1.835Zm-6 0a.612.612 0 1 1-.612.612.613.613 0 0 1 .616-.612Zm6.608 10.493a.613.613 0 0 1-.611.612H1.836a.613.613 0 0 1-.612-.612V3.059a.613.613 0 0 1 .612-.612H6.1a1.835 1.835 0 0 0 3.461 0h4.266a.613.613 0 0 1 .612.612Zm-4.8-5.782h3.61v1.224H9.636Zm0 2.478h3.61v1.224H9.636ZM7.044 8a1.927 1.927 0 1 0-3.117.025 3.06 3.06 0 0 0-1.479 2.618h1.223a1.836 1.836 0 0 1 3.671 0h1.224A3.061 3.061 0 0 0 7.044 8ZM5.476 6.18a.7.7 0 1 1-.7.7.7.7 0 0 1 .7-.7Z"
        fill="#185edf" //"var(--actionable-icon-color,#185edf)"
      />
    </svg>
  ),
  //"#6a8eff"
  deep_link_command_center_icon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="15.56"
      viewBox="-1 0 17.65 13.55"
    >
      <path
        data-name="carnet (1)"
        d="M13.827 1.224H9.562a1.836 1.836 0 0 0-3.461 0H1.836A1.838 1.838 0 0 0 0 3.059v8.657a1.838 1.838 0 0 0 1.836 1.835h11.993a1.838 1.838 0 0 0 1.834-1.835V3.059a1.838 1.838 0 0 0-1.836-1.835Zm-6 0a.612.612 0 1 1-.612.612.613.613 0 0 1 .616-.612Zm6.608 10.493a.613.613 0 0 1-.611.612H1.836a.613.613 0 0 1-.612-.612V3.059a.613.613 0 0 1 .612-.612H6.1a1.835 1.835 0 0 0 3.461 0h4.266a.613.613 0 0 1 .612.612Zm-4.8-5.782h3.61v1.224H9.636Zm0 2.478h3.61v1.224H9.636ZM7.044 8a1.927 1.927 0 1 0-3.117.025 3.06 3.06 0 0 0-1.479 2.618h1.223a1.836 1.836 0 0 1 3.671 0h1.224A3.061 3.061 0 0 0 7.044 8ZM5.476 6.18a.7.7 0 1 1-.7.7.7.7 0 0 1 .7-.7Z"
        fill="#6a8efff" //"var(--nonactionable-icon-color,#6a8efff)"
      />
    </svg>
  ),
  retweet_icon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="20"
      viewBox="0 0 15 13.15"
    >
      <defs>
        <style>
          {`.a { fill: none; stroke:  #3b5175; stroke-width: 1.62px; }`}
        </style>
      </defs>
      <path
        className="a"
        d="M12.52 11.63H5.13a1.64 1.64 0 0 1-1.64-1.64V2.53"
      />
      <path
        className="a"
        d="m.57 5.44 2.99-2.99 2.99 2.99M5.51 0.81h7.38a1.64 1.64 0 0 1 1.64 1.64v7.38"
      />
      <path className="a" d="m17.44 6.96-2.99 2.99-2.99-2.99" />
    </svg>
  ),

  retweet_white_icon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 15 13.15"
    >
      <defs>
        <style>
          {`.a { fill: none; stroke: var(--nonactionable-icon-color, #fff); stroke-width: 1.62px; }`}
        </style>
      </defs>
      <path
        className="a"
        d="M12.52 11.63H5.13a1.64 1.64 0 0 1-1.64-1.64V2.53"
      />
      <path
        className="a"
        d="m.57 5.44 2.99-2.99 2.99 2.99M5.51 0.81h7.38a1.64 1.64 0 0 1 1.64 1.64v7.38"
      />
      <path className="a" d="m17.44 6.96-2.99 2.99-2.99-2.99" />
    </svg>
  ),
  share_q_icon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 15 13.15"
    >
      <defs>
        <style>
          {
            ".a{fill:none;stroke:var(--nonactionable-icon-color,#3b5175);stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"
          }
        </style>
      </defs>
      <path
        className="a"
        d="M16.661 8.706A7.956 7.956 0 0 0 1.442 5.461M1.155 2.316v3.485M4.64 5.801H1.155M15.969 11.95A7.956 7.956 0 0 1 .75 8.706M16.256 15.095V11.61M12.772 11.61h3.485"
      />
    </svg>
  ),
  share_q_white_icon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 15 13.15"
    >
      <defs>
        <style>
          {
            ".a{fill:none;stroke:var(--nonactionable-icon-color,#fff);stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"
          }
        </style>
      </defs>
      <path
        className="a"
        d="M16.661 8.706A7.956 7.956 0 0 0 1.442 5.461M1.155 2.316v3.485M4.64 5.801H1.155M15.969 11.95A7.956 7.956 0 0 1 .75 8.706M16.256 15.095V11.61M12.772 11.61h3.485"
      />
    </svg>
  ),
  video_view_white_icon: (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10.267">
      <g fill="var(--nonactionable-icon-color,#fff)">
        <path
          data-name="Path 21796"
          d="M13.974 4.975A7.789 7.789 0 0 0 7 0 7.789 7.789 0 0 0 .028 4.975a.467.467 0 0 0 0 .317A7.789 7.789 0 0 0 7 10.267a7.789 7.789 0 0 0 6.974-4.975.467.467 0 0 0 0-.317ZM7 9.334a6.93 6.93 0 0 1-6.034-4.2A6.929 6.929 0 0 1 7 .934a6.929 6.929 0 0 1 6.034 4.2A6.93 6.93 0 0 1 7 9.334Z"
        />
        <path
          data-name="Path 21797"
          d="M7 2.333a2.8 2.8 0 1 0 2.8 2.8 2.8 2.8 0 0 0-2.8-2.8ZM7 7a1.867 1.867 0 1 1 1.867-1.867A1.867 1.867 0 0 1 7 7Z"
        />
      </g>
    </svg>
  ),
  video_view_icon: (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10.267">
      <g fill="var(--nonactionable-icon-color,#2d3e5c)">
        <path
          data-name="Path 21796"
          d="M13.974 4.975A7.789 7.789 0 0 0 7 0 7.789 7.789 0 0 0 .028 4.975a.467.467 0 0 0 0 .317A7.789 7.789 0 0 0 7 10.267a7.789 7.789 0 0 0 6.974-4.975.467.467 0 0 0 0-.317ZM7 9.334a6.93 6.93 0 0 1-6.034-4.2A6.929 6.929 0 0 1 7 .934a6.929 6.929 0 0 1 6.034 4.2A6.93 6.93 0 0 1 7 9.334Z"
        />
        <path
          data-name="Path 21797"
          d="M7 2.333a2.8 2.8 0 1 0 2.8 2.8 2.8 2.8 0 0 0-2.8-2.8ZM7 7a1.867 1.867 0 1 1 1.867-1.867A1.867 1.867 0 0 1 7 7Z"
        />
      </g>
    </svg>
  ),
  clock_icon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 18 18.15"
      fill="currentColor"
      className="clock-icon"
      style={{ color: "var(--nonactionable-icon-color,#3b5175)" }} // nonactionable-icon-color
    >
      <path d="M9 2.25a6.75 6.75 0 1 1-6.75 6.75A6.75 6.75 0 0 1 9 2.25m0-1.5A8.25 8.25 0 1 0 17.25 9 8.25 8.25 0 0 0 9 .75Z" />
      <path d="M12.75 12a.75.75 0 0 1-.375-.112L8.25 9.413V5.25a.75.75 0 0 1 1.5 0V8.75l3.375 2.025A.75.75 0 0 1 12.75 12Z" />
    </svg>
  ),
  mention_dashboard_trends_icon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 18 18"
    >
      <path data-name="Path 13929" d="M0 0h18v18H0Z" fill="none" />
      <path
        data-name="Path 13930"
        d="m12 4.5 1.718 1.717-3.66 3.66-3-3L1.5 12.443 2.558 13.5l4.5-4.5 3 3 4.725-4.717L16.5 9V4.5Z"
        fill="#185edf" //"var(--actionable-icon-color,#185edf)"
      />
    </svg>
  ),
};

export const getCommandCenterIcon = (status = null) => {
  switch (status) {
    case "facebook_like_white":
    case "facebook_like":
    case "upvote_white":
    case "upvote":
    case "facebook_share":
    case "facebook_share_white":
    case "instagram_share":
    case "instagram_share_white":
    case "youtube_share":
    case "youtube_share_white":
    case "video_view":
    case "video_view_white":
    case "like_icon":
    case "like_white_icon":
    case "comment_icon":
    case "comment_white_icon":
    case "postClick_white":
    case "postClick_black":
    case "delete_post":
    case "hide_post":
    case "deep_link_icon": // actionable
    case "deep_link_command_center_icon": // actionable
    case "retweet_white_icon":
    case "retweet_icon":
    case "share_q_white_icon":
    case "share_q_icon":
    case "video_view_white_icon":
    case "video_view_icon":
    case "marked_influencer_yellow": // harcode yellow
    case "marked_influencer_blue": // hardcode blue
    case "marked_influencer_command_center_blue": // hardcoded blue
    case "clock_icon":
    case "mention_dashboard_trends_icon":
      return CommandCenterIcon?.[status];
    default:
      return "";
  }
};
